module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAADm5+jm5+jm5+jm5+jm5+jm5+jm5+ipqao7ODkjHyBclVLDAAAAB3RSTlMAYL8AIM/vi50ITwAAAH5JREFUeF7t1rERQEAQheFXg0QsUsBSgVEBPYgJrA7MKOEqcFel+GbO7Qqxf/zl7wEoOFtFBOpZaCQ0k4TWDi2LDShlNKOW0QJW9Ha0uZDI7xE6QrIzQi6NfITCTf9BhgwZMmRIng15gPRT9u01Vx0a1TVSnSzVXdMdPyL5Ql6HHJByqjTnRAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f533.png
// module id = 1126
// module chunks = 0